import { queryClient } from "@app/config/api/api";
import { intercomJwtOptions } from "@app/queries/auth";

export async function getIntercomJWT(): Promise<string> {
  const response = await queryClient.fetchQuery(intercomJwtOptions);
  return response.jwt;
}
